import { render, staticRenderFns } from "./LiftUse.vue?vue&type=template&id=9aca4f92&scoped=true&"
import script from "./LiftUse.vue?vue&type=script&lang=ts&"
export * from "./LiftUse.vue?vue&type=script&lang=ts&"
import style0 from "./LiftUse.vue?vue&type=style&index=0&id=9aca4f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aca4f92",
  null
  
)

component.options.__file = "LiftUse.vue"
export default component.exports